export default __webpack_public_path__ + "static/Kia Ceed-cc264464b082f25d7957141e26252eda.jpg";